/* eslint-disable import/prefer-default-export */
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    let links = project.getNodeLinks(feature, 'for_loop_iterate');
    let iterateCode = '';
    let doneCode = '';
    if (links.length > 0) {
        const link = links[0];
        iterateCode += `/****${link.getSourceId()}****/`;
    }
    links = project.getNodeLinks(feature, 'for_loop_done');
    if (links.length > 0) {
        const link = links[0];
        doneCode += `/****${link.getSourceId()}****/`;
    }

    links = project.getNodeLinks(feature, 'for_loop');

    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        const start = project.getNodeParameter(link, 'start');
        const end = project.getNodeParameter(link, 'end');
        const counterName = `counter_${link.getID()}`;
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
for (int current_iteration=0; current_iteration<=${end}; current_iteration++) {
    ${iterateCode}
}
${doneCode}`,
        });
    }

    return blocks;
};
